import { render, staticRenderFns } from "./configuracao-integracao-operadora.vue?vue&type=template&id=5168952e&scoped=true"
import script from "./configuracao-integracao-operadora.vue?vue&type=script&lang=ts"
export * from "./configuracao-integracao-operadora.vue?vue&type=script&lang=ts"
import style0 from "./configuracao-integracao-operadora.vue?vue&type=style&index=0&id=5168952e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168952e",
  null
  
)

export default component.exports